import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const adoptShopifyMarkets = {
  name: "adoptShopifyMarkets" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    adopted: z.number(),
    failed: z.number(),
    errors: z.array(
      z.object({ countryCodes: z.array(z.string()), message: z.string() }),
    ),
  }),
};
